import React, { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { DropdownList } from 'react-widgets';
import { GetInventoryCategoryList } from '../../../API/Inventory';
import { CreateJobReadyItem, GetJobReadyItem } from '../../../API/JobReadyInventory';

export default props => {
    const [jobReadyItem, setJobReadyItem] = useState({
        inventoryJobReadyItemId: 0,
        itemName: "",
        inventoryCategoryId: 0
    });
    const [showAlert, setShowAlert] = useState(false)

    const [categories, setCategories] = useState([])
    const [category, setCategory] = useState(null)

    useEffect(() => {
        GetInventoryCategoryList()
            .then(res => {
                setCategories(res.data)
                if (props.match.params.id !== 'new') {
                    GetJobReadyItem(props.match.params.id)
                        .then(item => {
                            setJobReadyItem(item.data)
                            let cat = res.data.find(x => x.inventoryCategoryId === item.data.inventoryCategoryId)
                            setCategory(cat)
                        })
                }
            })
    }, [props.match.params.id])

    const changeItem = (key, value) => {
        let s = { ...jobReadyItem }
        s[key] = value;
        setJobReadyItem(s)
    }

    const submitNew = () => {
        let payload = { ...jobReadyItem }
        payload.inventoryCategoryId = category.inventoryCategoryId
        CreateJobReadyItem(payload)
            .then(res => {
                setShowAlert(true)
            })
    }

    return (
        <div>
            <form action="#" onSubmit={(e) => { e.preventDefault(); submitNew() }}>
                <div className="row mt-3">
                    <div className="col">
                        <h3>Job Ready Item Editor</h3>
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <small>Job Ready Item Name</small>
                        <input className="enc-input-100" placeholder="Job Ready Item Name" value={jobReadyItem.itemName} onChange={e => changeItem('itemName', e.target.value)} required />
                    </div>
                </div>
                <div className="row mt-2">
                    <div className="col">
                        <small>Item Category</small>
                        <DropdownList
                            data={categories}
                            textField="name"
                            onChange={setCategory}
                            value={category}
                            placeholder="Select a Category"
                        />
                    </div>
                </div>
                <div className="row mt-1">
                <div className="col-6">
                        <Alert variant="success" show={showAlert} dismissible onClose={() => setShowAlert(false)}>
                            <strong>Successfully Saved Job Ready Item</strong>
                        </Alert>
                    </div>
                    <div className="col text-right">
                        <Button className="enc-button" type='submit'>Save Item</Button>
                    </div>
                </div>
            </form>
        </div>
    )
}
